import ApprovedIcon from '@assets/images/approved-icon.svg?react'
import CheckIcon from '@assets/images/check-icon.svg?react'
import ClockIcon from '@assets/images/clock-icon.svg?react'
import { SeverityInfoIcon } from '@atbay/icons'
import { useCustomTheme } from '@/core/theme'
import SvgStatusClean from '@components/svg/status-clean'
import SvgStatusCritical from '@components/svg/status-critical'
import SvgStatusModerate from '@components/svg/status-moderate'
import SvgStatusWarning from '@components/svg/status-warning'

interface Props {
    status: TIssueSeverity | TCaseSeverity | TIssueStatus
    reverse?: boolean
    width?: string
    height?: string
}

const AssetIcon = ({
    status,
    reverse,
    width = '24px',
    height = '24px',
}: Props) => {
    const theme = useCustomTheme()

    if (status === 'critical') {
        return (
            <SvgStatusCritical
                primaryColor={theme.colors.greys[50]}
                dataTestId="severity-critical"
                width={width}
                height={height}
            />
        )
    }

    if (status === 'important' || status === 'high') {
        return (
            <SvgStatusWarning
                reverse={reverse}
                primaryColor={theme.colors.greys[50]}
                dataTestId="severity-important"
                width={width}
                height={height}
            />
        )
    }

    if (status === 'moderate' || status === 'medium') {
        return (
            <SvgStatusModerate
                reverse={reverse}
                primaryColor={theme.colors.greys[50]}
                dataTestId="severity-moderate"
                width={width}
                height={height}
            />
        )
    }

    if (status === 'clean') {
        return (
            <SvgStatusClean
                reverse={reverse}
                primaryColor={theme.colors.greys[50]}
                dataTestId="severity-clean"
                width={width}
                height={height}
            />
        )
    }

    if (status === 'in_review') {
        return (
            <ClockIcon
                data-testid="severity-in_review"
                color={theme.colors.greys[50]}
                width={width}
                height={height}
            />
        )
    }

    if (status === 'approved') {
        return (
            <ApprovedIcon
                data-testid="severity-approved"
                color={theme.colors.greys[50]}
                width={width}
                height={height}
            />
        )
    }

    if (status === 'resolved') {
        return (
            <CheckIcon
                data-testid="severity-resolved"
                color={theme.colors.greys[50]}
                width={width}
                height={height}
            />
        )
    }

    if (status === 'informational') {
        return (
            <SeverityInfoIcon
                data-testid="severity-info"
                color={theme.colors.greys[50]}
                width={width}
                height={height}
            />
        )
    }

    return null
}

export default AssetIcon
